<div class="mt-5">

  @if (!childActive()) {

  <dpac-page-layout title="Gestione collezioni" mode="stack" [actionButton]="actionButton"
    (actionClick)="openNuovaCollezione()">
    @if (state().paginazione.totalElements > 0 || hasSearchTerm()) {
      <!-- Barra ricerca -->
      <dpac-search placeholder="Cerca" (search)="onSearch($event)" />

      <!-- Info risultati -->
      <div class="flex justify-between items-center bg-primary-50 mt-4 p-5">
        <span class="text-sm">
          Tot. Risultati {{ state().paginazione.totalElements }}
        </span>
      </div>

      @if (state().paginazione.totalElements > 0) {
        <dpac-table [dataSource]="row()" [configTable]="tableConfig()" [totalTable]="state().paginazione.totalElements"
          (rowClick)="onRowClick($event)" (returnActionTable)="onTableAction($event)" />

        <!-- Paginazione -->
        @if (state().paginazione.totalPages > 0) {
        <div class="mt-2">
          <dpac-paginator [currentPage]="currentPage()" [totalPages]="totalPages()"
          [totalRows]="state().paginazione.totalElements" [pageSize]="state().paginazione.totalElementsForPage"
          (pageChange)="goToPage($event)" />
        </div>
        }
      } @else if (!loading()) {
        <div class="mt-4">
          <dpac-empty-box [emptyStateConfig]="emptySearchStateConfig" />
        </div>
      }
    } @else if (!loading()) {
      <div class="mt-4">
        <dpac-empty-box [emptyStateConfig]="emptyStateConfig" (emptyStateAction)="openNuovaCollezione()" />
      </div>
    }
  </dpac-page-layout>
  }
  <router-outlet></router-outlet>

</div>
